export const esSheetColumns = {
  'Abyss Fabric Component ID': 'risk_equipment_tag',
  'Level 1 Component': 'risk_level_1_component',
  'Level 2 Sub-Component': 'risk_level_2_component',
  'Facility/Dock/Berth': 'risk_dock',
  Structure: 'risk_structure',
  Component: 'risk_component_type',
  'Service Code': 'code',
  'Service Group': 'group',
  Member: 'risk_member_id',
  Elevation: 'risk_elevation',
  Sizing: 'risk_sizing',
  'Material Type': 'risk_material_type',
  'Damage Class': 'risk_damage_class',
  'Damage Class Description': 'risk_damage_class_description',
  'Inspection Method': 'risk_inspection_method',
  'EDD Method': 'risk_edd_method',
  'Governing Damage Media': 'risk_governing_damage_media',
  'Inspection Date': 'risk_inspection_date',
  'Defect Codes': 'risk_defect_codes',
  'Damage Mechanism Metric': 'risk_damage_mechanism_metric',
  'Damage Mechanism Size': 'risk_damage_mechanism_size',
  'Subsea Cathodic Protection': 'risk_subsea_cathodic_protection',
  'Subsea Ultrasonic Testing': 'risk_subsea_ultrasonic_testing',
  'Subsea General Visual Inspection': 'risk_subsea_general_visual_inspection',
  'Additional Remarks': 'risk_additional_remarks',
  'Task Description': 'risk_task_description',
  'Task Frequency': 'risk_task_frequency',
  'Task Responsibility': 'risk_task_responsibility',
};

export const serviceKeys = new Set(['code', 'group']);
